import { render } from "./PlansAddView.vue?vue&type=template&id=5ed7a17a"
import script from "./PlansAddView.vue?vue&type=script&lang=js"
export * from "./PlansAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__